export enum VisibilityType {
  Default = 1, // 予定名をそのまま表示
  Busy = 2, // 予定ありと表示
}
